import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'Mailboxes/Segments'

export const EDIT_ASYNC = createAsyncTypes('EDIT_ASYNC', typeKey)
export const SELECT_TOGGLE = `${typeKey}/SELECT_TOGGLE`
